
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Badminton Competition  2024</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title mt-3">
                    <h4>Badminton Competition 2024 </h4>
                </div>
                <div class="fide-chess-text">
                    <p>This is exactly the mindset behind the plethora of sports activities and competitions.</p>
                    <p>"Serving up excellence, one shuttle at a time. Thrilled to inaugurate the 2024 Badminton Competition at GHRCEM Pune!</p>
                </div>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-pune-1.avif"
                        alt="GHRSCF" />

                </div>
            </div>
        </div>
        <div class="row  row-cols-1 row-cols-lg-3 mt-5">
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3 class="fs-4 lh-base">Buldhana District badminton Championship 2024<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/buldhana-district-badminton-championship" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3 class="fs-4 lh-base">Yonex-Sunrise G H Raisoni Memorial Vidarbha Level Badminton Tournament <i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/badminton-compe-vidarbh" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3 class="fs-4 lh-base">Yonex-Sunrise G H Raisoni Memorial Vidarbha Level Badminton Tournament <i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/badminton-compe-vidarbh" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3 class="fs-4 lh-base">Badminton Competition Pune 2024<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/badminton-compe-pune" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3 class="fs-4 lh-base">Raisoni Badminton Super Series<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/badminton-series" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3 class="fs-4 lh-base">Women's Badminton Tournament 2024<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/sadabai-raisoni-womens-batminton" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3 class="fs-5 lh-base"> G H Raisoni Memorial Nagpur District Badminton Tournament<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/badminton-tournament" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
